/**
 * Cruza el listado de instalaciones con las filas de asignación
 * (dash_users_installations) de un usuario, marcando cada instalación con
 * su `assigned` (la fila de asignación, o undefined si no tiene acceso).
 * Compartido entre la tabla de usuarios y la vista "por instalación" para
 * no repetir el mismo cruce en dos sitios.
 */
export function buildInstallationsWithAssignment(
  installations: any[],
  assignmentRows: any[],
  userId: number | string | null
): any[] {
  if (!userId) {
    return installations.map(installation => ({
      ...installation,
      assigned: false,
    }));
  }

  return installations.map(installation => {
    const assigned = assignmentRows.find(
      (row: any) =>
        Number(row.usuario_id) === Number(userId) &&
        Number(row.installation_id) === Number(installation.id)
    );

    return { ...installation, assigned };
  });
}
